import React, { useCallback, useMemo, useRef } from 'react'

/** The idea with this hook is that it produces a constant reference to a function which remains constant
 * even when the deps change (but the function itself receives updated variables).
 * Essentially, this is useCallback() that can be safely fed into useEffect() without unexpected updates. */
export default function useConstCallback<T extends (...params: Array<any>) => any>(func: T, deps?: React.DependencyList) {
  const ref = useRef<(...params: Parameters<T>) => ReturnType<T>>(func)

  useMemo(() => {
    ref.current = func
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return useCallback((...params: Parameters<T>) => ref.current(...params), [])
}
